<template>
  <div id="firstApp" class="firstApp">
    <el-dialog :title="diagTitle"
      :visible.sync="showFlag"
      :close-on-click-modal="false"
      :before-close="handleClose"
      >
      <div class="firstAppContent">
            <span class="title">应用名称<span style="color: red">*</span>：</span>
            <el-input v-model="appClientName" placeholder="请输入应用名称(必填)"></el-input>
            <span class="title">应用描述：</span>
            <el-input v-model="appRemark" placeholder="请输入应用描述"></el-input>
            <span class="title">公司名称：</span>
            <el-input v-model="appCompany" placeholder="请输入公司名称"></el-input>
            <el-button v-if="type === 'newApp'" size="small" type="success" class="btnCreate" @click="submitCreate">确定创建</el-button>
            <el-button v-if="type === 'updateApp'" size="small" type="success" class="btnCreate" @click="submitUpdate">确定修改</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { BASE_URL } from 'src/api/api';
import { createApp, updateApp } from 'src/utils/appUtils';
import { createBucket } from 'src/utils/modelUtils';
import { setUserName } from 'src/utils/loginUtils';

export default {
    name: 'fileMngUpload',
    components: {
    },
    data() {
        return {
            showFlag: false, // 关闭模态框
            diagTitle: '',
            type: '',
            appClientName: '',
            appRemark: '',
            appCompany: '',
        };
    },
    mounted() {

    },
    methods: {

        //  登录显示
        Open(type, data) {
            this.type = type;
            if (type === 'newApp') {
                this.diagTitle = '创建应用';
                // 数据清理
                this.appClientName = '';
                this.appRemark = '';
                this.appCompany = '';
            } else if (type === 'updateApp') {
                this.diagTitle = '修改应用';
                this.appClientName = data.clientName;
                this.appRemark = data.remark;
                this.appCompany = data.company;
            }
            this.showFlag = true; //  打开模态框
        },
        handleClose() {
            this.showFlag = false; //  关闭模态框
            if (this.type === 'newApp') {
                // 去起步页面
                this.$router.push('/devcenter/getstarted');
            }
        },
        submitCreate() {
            // 创建应用
            const _self = this;
            // 数据校验
            if (_self.appClientName === '') {
                _self.$message.error('请输入应用名称');
                return;
            }
            const data = {
                remark: _self.appRemark,
                clientName: _self.appClientName,
                company: _self.appCompany,
            };
            createApp(data).then(res => {
                if (res) {
                    _self.$message({
                        message: '创建成功',
                        type: 'success',
                    });
                    // 改变状态，
                    // _self.$parent.initPage()
                    _self.$store.commit('SET_USERID', {
                        CLIENT_ID: res.data.clientId,
                        CLIENT_SECRET: res.data.clientSecret,
                    });
                    // 保存用户名
                    setUserName(res.data.owner);
                    // 创建对应bucket
                    _self.createNewBucket(res.data.owner);
                    // todo
                    // 创建对应转换数据的bucket 目前后台自动创建
                    // _self.createNewBucket('translation_result_v2')
                    // 开启保存具体信息对话框
                    _self.$store.commit('SET_USERSTATUS', true);
                    // 关闭对话框
                    _self.showFlag = false;
                } else {
                    _self.$message.error('创建失败');
                }
            });
        },
        createNewBucket(bucketKey) {
            // 创建默认的bucket
            const _self = this;
            const data = {
                bucket_key: bucketKey,
            };
            createBucket(data).then(res => {
                console.log('创建bucket成功');
            });
        },
        submitUpdate() {
            // 修改应用
            const _self = this;
            // 数据校验
            if (_self.appClientName === '') {
                _self.$message.error('应用名称不能为空');
                return;
            }
            const data = {
                remark: _self.appRemark,
                clientName: _self.appClientName,
                company: _self.appCompany,
            };
            updateApp(data).then(res => {
                if (res) {
                    _self.$message({
                        message: '修改应用信息成功',
                        type: 'success',
                    });
                    // 关闭对话框
                    _self.$parent.initPage();
                    _self.showFlag = false;
                } else {
                    _self.$message.error('修改应用信息失败');
                }
            });
        },
    },
};
</script>
<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  .firstApp >>> .el-upload__input
    display none
  .firstApp >>>  .el-dialog
    width: 450px
  .firstApp >>>  .el-dialog__header
    width: 450px
    height:40px
    line-height: 40px
    font-family: "MicrosoftYaHei"
    padding: 0
    padding-left: 30px
    display: flex
    align-items: center
    .el-dialog__title
      color $font-black
      font-size: 15px;
    .el-dialog__headerbtn
      top 0px
      .el-dialog__close
        color $font-black
  .firstApp
    .firstAppContent
        .title
           line-height: 36px;
        .btnCreate
            margin: 20px 0px 0px 300px;
            width: 100px;
            height: 40px;
            border-radius: 20px;
            border: 0px;
            background-color #0C78E2
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/theFirstApp.vue